export default {
  planSearchQuery () {
    this.searchPlans(this.planSearchQuery)
  },
}
